<template>
    <section class="page-banner" :style="{ border: colour ? `3px solid ${colour}` : 'none' }">
        <div class="page-banner__glow page-banner__glow--left"></div>
        <div class="page-banner__glow page-banner__glow--right"></div>

        <div class="page-banner__content">
            <h1 class="page-banner__title">{{ title }}</h1>
            <p v-if="subtext" class="page-banner__subtext">{{ subtext }}</p>
        </div>
    </section>
</template>

<script>
export default {
    name: 'PageBanner',

    props: {
        title: {
            type: String,
            required: true
        },
        subtext: {
            type: String,
            default: ''
        },
        colour: {
            type: String,
            default: null
        }
    }
}
</script>

<style scoped>
.page-banner {
    position: relative;
    overflow: hidden;
    padding: 14px 24px;
    color: #f7fbf8;
    background:
        radial-gradient(circle at top left, rgba(244, 190, 104, 0.35), transparent 35%),
        radial-gradient(circle at bottom right, rgba(90, 135, 124, 0.35), transparent 30%),
        linear-gradient(135deg, #24454a 0%, #3c645d 42%, #8aa06f 100%);
}

.page-banner__glow {
    position: absolute;
    border-radius: 999px;
    filter: blur(20px);
    opacity: 0.5;
    pointer-events: none;
}

.page-banner__glow--left {
    width: 180px;
    height: 180px;
    top: -50px;
    left: -40px;
    background: rgba(255, 214, 153, 0.28);
}

.page-banner__glow--right {
    width: 220px;
    height: 220px;
    right: -70px;
    bottom: -90px;
    background: rgba(255, 255, 255, 0.16);
}

.page-banner__content {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
    text-align: left;
}

.page-banner__title {
    margin: 0;
    font-size: clamp(1.5rem, 3vw, 1.9rem);
    font-weight: 600;
    line-height: 1.2;
}

.page-banner__subtext {
    max-width: 760px;
    margin: 0;
    font-size: 0.95rem;
    line-height: 1.45;
    color: rgba(247, 251, 248, 0.88);
}

@media (max-width: 700px) {
    .page-banner {
        padding: 16px;
    }
}
</style>
